import styled from '@emotion/styled';

export const AuthScreenStory = styled.div`
  display: flex;
`;

export const AuthScreen = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  background-color: #f4f5f7;
`;

export const MainBanner = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 6px;
`;

export const AuthButton = styled.div`
  display: flex;
  justify-content: center;
  font-size: 21px;
  margin-bottom: 20px;
`;

export const MainHeader = styled.h2`
  display: flex;
  justify-content: center;
`;

export const SeparateLine = styled.hr`
  width: 100%;
`;
